import { useState, useEffect, useRef } from "react";
import Logo from "../../images/57logo.jpeg";
import { Modal, Button } from "react-bootstrap";
import Sidemenubar from "./Sidemenubar";
import { useNavigate } from "react-router-dom";
import Apiservice from "../Apiservice";
import Swal from "sweetalert2";

const Header = () => {
    const navigate = useNavigate();
    const [showLogOutModal, setShowLogOutModal] = useState(false);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);
    const headerRef = useRef(null);

    const userRole = localStorage.getItem("role_id"); // Get user role from localStorage (admin or user)

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleLogout = () => {
        setShowLogOutModal(true);
    };

    const handleLogoutConfirm = async () => {
        const token = localStorage.getItem("access_token");
        const userType = localStorage.getItem("userType");
        let data = {
            "userType": userType
        };
        const headers = { access_token: token };
        let result = await Apiservice.Logout(data, headers);
        console.log("result", result)
        if (result.success === true) {
            localStorage.clear();
            window.location.replace("/login");
        } else {
            alert(result.message)
        }

    };

    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                isSidebarOpen &&
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                !headerRef.current.contains(event.target)
            ) {
                setIsSidebarOpen(false);
            }
        };

        if (isSidebarOpen) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, [isSidebarOpen]);

    return (
        <>
            <div
                ref={headerRef}
                className="navbar navbar-expand"
                style={{ position: "relative", overflow: "hidden", height: "13vh", userSelect: "none" }}
            >
                <div
                    className="container-fluid header-bg"
                    style={{
                        height: "10vh",
                        position: "fixed",
                        top: "0px",
                        zIndex: 999,
                    }}
                >
                    {windowSize.width < 768 ? (
                        <a
                            className="navbar-brand"
                            href="#"
                            onClick={toggleSidebar}
                        >
                            <img
                                src={Logo}
                                alt=""
                                className="img-fluid"
                                style={{ height: "57px", width: "57px", cursor: "pointer" }}
                            />
                        </a>
                    ) : (
                        <a className="navbar-brand" href="#">
                            <img
                                src={Logo}
                                alt=""
                                className="img-fluid"
                                style={{ height: "57px", width: "57px", cursor: "pointer" }}
                            />
                        </a>
                    )}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="header-text">
                        <ul className="navbar-nav me-auto mb-lg-0">
                            <li className="nav-item" onClick={handleLogout}>
                                <a href="#" className="nav-link text-white">
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Sidebar */}
                {/* {isSidebarOpen && (
                    <div
                        ref={sidebarRef}
                        style={{
                            position: "fixed",
                            top: "10vh",
                            left: isSidebarOpen ? 0 : "-100%", // Ensuring it starts offscreen
                            width: "300px",
                            height: "90vh",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            zIndex: 1000,
                            color: "white",
                            padding: "10px",
                            overflowY: "auto",
                            transition: "transform 0.3s ease-in-out", // Smooth sliding effect
                        }}
                    >
                        <Sidemenubar userRole={userRole} onClick={() => setIsSidebarOpen(false)} />
                    </div>
                )} */}

                <div
                    ref={sidebarRef}
                    style={{
                        position: "fixed",
                        top: "10vh",
                        left: 0,
                        width: "300px",
                        height: "90vh",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        zIndex: 1000,
                        color: "white",
                        padding: "10px",
                        overflowY: "auto",
                        transform: isSidebarOpen ? "translateX(0)" : "translateX(-100%)",
                        transition: "transform 0.3s ease-in-out",
                    }}
                >
                    <Sidemenubar userRole={userRole} onClick={() => setIsSidebarOpen(false)} />
                </div>


                {/* Logout Confirmation Modal */}
                <Modal show={showLogOutModal} onHide={() => setShowLogOutModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Logout</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to Logout?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowLogOutModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleLogoutConfirm}>
                            Logout
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
};

export default Header;
